<section class="pro-cards-list__container flex column justify-start">
  <app-pro-card *ngFor="let proCard of proCardsList" [proCardInfo]="proCard"> </app-pro-card>
</section>
